import React, { Children, cloneElement, FC, isValidElement, memo, ReactChild } from "react";
import { useMedia } from "react-use";

import { IHotjarProps } from "@/browser";
import { Icon } from "@/components/Icon";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, FloatedList, TStyleFlexAlign } from "@/eworkitComponents";

interface Props extends IHotjarProps {
  children: Array<ReactChild | null | false | undefined>;
  direction?: "row" | "column";
  itemAlign?: TStyleFlexAlign;
  hideFirstDot?: boolean;
}

export const TextListWithDot: FC<Props> = memo(({ children, direction = "row", itemAlign, hideFirstDot, ...rest }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const elementRenderer = (child: any) => {
    if (isValidElement(child)) {
      return cloneElement(child);
    }

    return null;
  };

  const items = Children.map(children, (child, idx) => {
    if (child) {
      return (
        <Flex innerMargin="sm" key={idx} align={itemAlign ?? "center"}>
          {(idx === 0 || !children[idx - 1]) && (hideFirstDot || (!isSmallScreen && direction === "row")) ? null : (
            <Icon key={`icon-${idx}`} color="grey3" icon="circle" size="xxxs" />
          )}
          {Array.isArray(child) ? child.map(elementRenderer) : elementRenderer(child)}
        </Flex>
      );
    }
    return null;
  });

  return (
    <FloatedList align="center" {...rest}>
      {items}
    </FloatedList>
  );
});
